import { format, parse } from 'date-fns';
export function setNegativeValue(value) {
    return Math.sign(value) < 0 ? value : value * -1;
}
export function formatCurrency(value, options) {
    const { currency = 'USD', maximumFractionDigits = 2, minimumFractionDigits = maximumFractionDigits } = options || {};
    const absValue = Math.abs(value);
    const formattedValue = absValue.toLocaleString('en-US', {
        style: 'currency',
        currency,
        maximumFractionDigits,
        minimumFractionDigits
    });
    return value < 0 ? `-${formattedValue}` : formattedValue;
}
export function formatPercents(value, options) {
    const { maximumFractionDigits = 2, minimumFractionDigits = maximumFractionDigits } = options || {};
    return value.toLocaleString('en-US', { style: 'percent', maximumFractionDigits, minimumFractionDigits });
}
export function formatTransactionType(type) {
    return type;
}
export function formatSsn(value) {
    return value.substr(0, 3) + '-' + value.substr(3, 2) + '-' + value.substr(5, 4);
}
export function removeMaskFromPhoneNumber(maskedPhoneNumber) {
    return maskedPhoneNumber.replace(/\D/g, '');
}
export function formatDate(dateString) {
    const date = parse(dateString, 'MM/dd/yyyy', new Date());
    return format(date, 'yyyy-MM-dd');
}
export function formatDateToUSFormat(date) {
    const isoDate = date.substring(0, date.indexOf('T')) || date;
    const dateParts = isoDate.split('-');
    const dd = dateParts[2].length === 1 ? '0' + dateParts[2] : dateParts[2];
    const mm = dateParts[1].length === 1 ? '0' + dateParts[1] : dateParts[1];
    return `${mm}/${dd}/${dateParts[0]}`;
}
